import { Geofence, getGeofenceIdentifier } from "@/api/v1/geofence-api"
import { ColumnDef } from "@tanstack/react-table"
import { Button } from "@/components/ui/button"
import { Link } from "@tanstack/react-router"
import { Badge } from "@/components/ui/badge"
import { Edit, Eye } from "lucide-react"
import { DeleteGeofenceAction } from "./delete-action"

export const columns: ColumnDef<Geofence>[] = [
    {
        accessorKey: "name",
        header: "Name",
        cell: ({row}) => {
            const geofence = row.original
            const identifier = getGeofenceIdentifier(geofence)
            return (
                <Link to={`/geofences/$geofenceId`} params={{ geofenceId: String(identifier) }} className="hover:underline">
                    {geofence.name}
                </Link>
            )
        }
    },
    {
        accessorKey: "type",
        header: "Type",
        // cell: info => info.getValue(),
        cell: info => <Badge variant={'secondary'}>{info.getValue() as string}</Badge>
    },
    {
        accessorKey: "created_at",
        header: "Created At",
        cell: info => new Date(info.getValue() as string).toLocaleString(),
    },
    {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => {
            const geofence = row.original
            const identifier = getGeofenceIdentifier(geofence)
            const identifierStr = String(identifier)
            return (
                <div className="flex gap-2">
                    <Button variant="ghost" size="icon" asChild>
                        <Link to={`/geofences/$geofenceId`} params={{ geofenceId: identifierStr }}>
                            <Eye className="h-4 w-4" />
                        </Link>
                    </Button>
                    <Button variant="ghost" size="icon" asChild>
                        <Link to={`/geofences/$geofenceId/edit`} params={{ geofenceId: identifierStr }}>
                            <Edit className="h-4 w-4" />
                        </Link>
                    </Button>
                    <DeleteGeofenceAction 
                        geofenceId={identifier} 
                        geofenceName={geofence.name} 
                    />
                </div>
            )
        },
    },
]
